/**
 * ============================================================================
 * USE MOUNTED HOOK
 * ============================================================================
 * 
 * Custom hook to track component mount status
 * Prevents state updates after component unmounts
 * Returns a stable function reference so dependent callbacks (e.g. loadMyProfile)
 * do not change every render and avoid infinite effect loops.
 */

import { useEffect, useRef, useCallback } from 'react';

/**
 * Mounted status hook
 * @returns {function(): boolean} Stable function that returns whether component is mounted
 */
export const useMounted = () => {
  const isMountedRef = useRef(true);

  useEffect(() => {
    isMountedRef.current = true;

    return () => {
      isMountedRef.current = false;
    };
  }, []);

  return useCallback(() => isMountedRef.current, []);
};

export default useMounted;
